import dayjs from 'dayjs';
import Image from 'next/image';

import Text from '~components/Text';
import useMedia from '~hooks/useMedia';
import { COMPANY_SOURCE, CompanyStates, SummarySalary } from '~types/company';
import { getSalaryRate } from '~utils/company/company';
import { millionFormattedtoString } from '~utils/formatted/number';
import { isEmpty } from '~utils/lodash/isEmpty';

import { S } from './style';

interface Props {
  salary: SummarySalary;
  companyStates: CompanyStates;
}
function SalaryCard({ salary, companyStates }: Props) {
  const { isMobile } = useMedia();

  const rate = getSalaryRate(salary.rate ?? 0);

  return (
    <S.SummaryCardItem>
      <S.Label>
        <img src={`/images/${isMobile ? 'money_m.png' : 'money.png'}`} alt='money' />
        <S.Title typography='midium150_C1'>예상평균연봉</S.Title>
      </S.Label>
      {companyStates.salary ? (
        <S.Content>
          <S.TitleWrapper>
            <Text typography={isMobile ? 'bold150_T1' : 'bold150_B1'}>
              {isEmpty(salary.salary)
                ? '수집 중..'
                : `${millionFormattedtoString(salary.salary)}만원`}
            </Text>
            {rate && rate <= 50 && !isEmpty(salary.salary) && <S.Badge>상위 {rate}%</S.Badge>}
          </S.TitleWrapper>
          <S.SubTitleWrapper>
            <S.SubTitle>
              <Text typography='midium120_C1'>월 세전 </Text>
              <Text typography='bold120_C1'>
                {isEmpty(salary.salary)
                  ? '수집 중..'
                  : `${millionFormattedtoString(Number(salary.salary) / 12).toLocaleString()}만원`}
              </Text>
            </S.SubTitle>
          </S.SubTitleWrapper>
          <S.Source typography='midium150_C1'>{`출처 : ${
            isEmpty(salary.source)
              ? '정보없음'
              : `${COMPANY_SOURCE[salary.source]} ${
                  salary.updatedAt ? dayjs(salary.updatedAt).format('YYYY.MM') : ''
                }`
          }`}</S.Source>
        </S.Content>
      ) : (
        <S.Content>
          <Text typography={isMobile ? 'bold150_T1' : 'bold150_B1'}>비공개</Text>
        </S.Content>
      )}
    </S.SummaryCardItem>
  );
}

export default SalaryCard;
